// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instance {
  padding: 20px;
  min-height: 40px;
  line-height: 20px;
  border: 2px solid #d4cfbe;
  border-left: 5px solid #b39841;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.instance .details-wrapper {
  display: flex;
}
.instance .details-wrapper .instance-details {
  margin: 0;
  display: flex;
}
.instance .details-wrapper .instance-details .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.instance .details-wrapper .instance-details .instance-title-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0 10px;
}
.instance .details-wrapper .instance-details p {
  margin-bottom: 5px;
}
.instance .buttons {
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/instance/instance.component.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;AARA;EAYI,aAAA;AADJ;AAXA;EAeM,SAAA;EACA,aAAA;AADN;AAfA;EAkBQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAAR;AArBA;EAyBQ,aAAA;EACA,sBAAA;EACA,eAAA;AADR;AA1BA;EA+BQ,kBAAA;AAFR;AA7BA;EAqCM,kBAAA;AALN","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.instance {\n  padding: 20px;\n  min-height: 40px;\n  line-height: 20px;\n  border: 2px solid @primary-50;\n  border-left: 5px solid @primary-90;\n  margin-top: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .details-wrapper {\n    display: flex;\n\n    .instance-details {\n      margin: 0;\n      display: flex;\n      .icon-wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n      }\n\n      .instance-title-wrapper {\n        display: flex;\n        flex-direction: column;\n        padding: 0 10px;\n      }\n\n      p {\n        margin-bottom: 5px;\n      }\n    }\n  }\n\n    .buttons {\n      margin-right: 20px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
